import React from 'react';
import _get from 'lodash/get';
import { Typography, Box, makeStyles } from '@material-ui/core';
import { getImageFile } from 'utils/stringUtils';

const useStyles = makeStyles(() => ({
  plainCardContainer: {
    display: 'flex',
    flexGrow: 1,
    marginBottom: 20,
    border: '1px solid #E9ECED',
  },
  imageContainer: {
    width: 84,
    height: 84,
    overflow: 'hidden',
    flexShrink: 0,
    marginRight: 20,

    '& > img': {
      maxWidth: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  plainCardTitle: {
    fontSize: '1.125rem',
  },
}));

const CoursePreviewCard = ({ item }) => {
  const classes = useStyles();

  const { title, subtitle } = _get(item, 'fields', {});
  const backgroundImage = getImageFile(
    _get(item, 'fields') || _get(item, 'fields.list.fields.0.fields'),
  );

  return (
    <div className={classes.plainCardContainer}>
      <div className={classes.imageContainer}>
        <img src={backgroundImage} alt="Series" />
      </div>
      <Box pt={0.5} pb={0.5}>
        <Box mb={0.5}>
          <Typography
            className={classes.plainCardTitle}
            variant="h5"
            color="primary"
          >
            {title}
          </Typography>
        </Box>
        <Typography variant="overline">{subtitle}</Typography>
      </Box>
    </div>
  );
};

export default CoursePreviewCard;
